import React, { useState, useEffect, useContext } from "react";
import "./AllForVote.scss";
import { createPortal } from "react-dom";

import { inject, observer } from "mobx-react";
import RootStore from "../../store/RootStore";
import { ThemeContext } from "../../store/ThemeProvider";
import { IComponentVote } from "../../component";
import Vote, { IVoteProps } from "./Vote";
import { alpha } from "../../utils/color";
import { isIphoneX, getPageSameType } from "../../utils/util";
import { clearAllBodyScrollLocks, disableBodyScroll } from "body-scroll-lock";
import intl from "react-intl-universal";
import ReactSVG from "react-svg";
import useRealBottomTab from "../ComponentNavigator/useRealBottomTab";

let voteContainer = window.document.createElement("div");
window.document.body.appendChild(voteContainer);

const AllForVote = (props: IVoteProps) => {
  const { show_search, show_result, show_count, data, backgroundColor } = props;
  const { componentColor, mainColor, h1Color, h2Color } =
    useContext(ThemeContext);

  const [realBottom, setRealBottom] = useState(0);
  const [expand, setExpand] = useState(false);

  useEffect(() => {
    let { template } = window.pageDetail;
    let paddingBottom = 0;
    paddingBottom += isIphoneX() ? 22 : 0;
    let shouldBorder = false;
    const { showNavigator } = useRealBottomTab();
    if (showNavigator) {
      paddingBottom += 49;
      shouldBorder = true;
    }

    setRealBottom(paddingBottom - 5);

    if (expand) {
      // disableBodyScroll(window.document.body);
    } else {
      clearAllBodyScrollLocks();
    }

    const onVotePopup = (event: any) => {
      let target_id = event.data;
      if (Number(target_id) == data.id) {
        setExpand(true);
      }
    };

    window.addEventListener("vote_popup", onVotePopup);

    return () => {
      window.removeEventListener("vote_popup", onVotePopup);
    };
  }, [expand]);
  
  

  return createPortal(
    <div
      className="vote-popup"
      style={{
        background: backgroundColor || alpha(componentColor, 1),
        bottom: realBottom,
        display: expand ? "block" : "none",
      }}
    >
      <div className="wrapper">
        <Vote {...props} />
      </div>
      <ReactSVG
        src={require("../../svg/x.svg")}
        className="x"
        style={{ fill: alpha(h1Color, 0.5) }}
        onClick={() => {
          setExpand(false);
        }}
      />
    </div>,
    voteContainer
  );
};

export default inject("rootStore")(observer(AllForVote));
